import { FormField } from '@sitecore-jss/sitecore-jss-forms';
import { FieldProps } from '@sitecore-jss/sitecore-jss-react-forms';

import { longDescriptionColor } from '../../contexts/FormTheme/formThemes';
import { RichTextViewModel } from '../../types/richText';

const RichText: React.FC<FieldProps<FormField<RichTextViewModel>>> = (props) => {
  const { field } = props;

  return (
    <>
      {!!field.model.value && (
        <div
          dangerouslySetInnerHTML={{ __html: field.model.value }}
          className={`px-6 font-normal ${longDescriptionColor}`}
        />
      )}
    </>
  );
};
export default RichText;
